import React from "react";
import "./portfolio.css";
import IMG1 from "../../assets/project-1.png";
import IMG2 from "../../assets/project-2.png";
import IMG3 from "../../assets/project-3.png";
import IMG4 from "../../assets/project-4.png";
import IMG5 from "../../assets/project-5.png";
import IMG6 from "../../assets/project-6.png";
import IMG7 from "../../assets/project-7.jpeg"

const data = [
  {
    id: 1,
    image: IMG6,
    title: "Edge Job Recruitment Application ",
    github: "https://github.com/drebeat",
    demo: "https://edge.ivyarc.com/",
  },
  {
    id: 2,
    image: IMG7,
    title: "E-Commerce Team Project",
    github: "https://github.com/drebeat",
    demo: "https://bamzi-ecommerce-project.netlify.app/",
  },

  {
    id: 3,
    image: IMG1,
    title: "Blog-Website Homepage",
    github: "https://github.com/drebeat",
    demo: "https://school-blog-app.herokuapp.com/",
  },
  {
    id: 4,
    image: IMG5,
    title: "Expenses-Calculator-App",
    github: "https://github.com/drebeat",
    demo: "https://whimsical-scone-ee7967.netlify.app",
  },
  {
    id: 5,
    image: IMG2,
    title: "Four-Cards-Grid",
    github: "https://github.com/drebeat",
    demo: "https://drebeat.github.io/Four-card-feature/",
  },
  {
    id: 6,
    image: IMG3,
    title: "A Simple Survey Form",
    github: "https://github.com/drebeat",
    demo: "https://drebeat.github.io/A-Survey-Form-Page/index.html",
  },
  {
    id: 7,
    image: IMG4,
    title: "Coming Soon Landing Page",
    github: "https://github.com/drebeat",
    demo: "https://drebeat.github.io/frontendmentor_challenge/",
  },
];

const Portfolio = () => {
  return (
    <section id="portfolio">
      <h5>My Recent Work</h5>
      <h2>Portfolio</h2>

      <div className="container portfolio__container">
        {data.map(({ id, image, title, github, demo }) => {
          return (
            <article key={id} className="portfolio__item">
              <div className="portfolio__item-image">
                <img src={image} alt={title} />
              </div>
              <h3>{title}</h3>
              <div className="portfolio__item-cta">
                <a href={github} className="btn">
                  Github
                </a>
                <a href={demo} className="btn btn-primary" target="_blank">
                  Live
                </a>
              </div>
            </article>
          );
        })}
      </div>
    </section>
  );
};

export default Portfolio;
